import { gsap, CustomEase } from '../global/gsap';

const initScaleScroll = (sections) => {
    sections.forEach((section) => {
        let scaleStart = 0.75;

        if (section.dataset.scaleStart) {
            scaleStart = Number(section.dataset.scaleStart);
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 90%',
                end: 'top: 10%',
                scrub: 1.1,
                invalidateOnRefresh: true
            },
        });

        gsap.set(section, {
            scale: scaleStart
        });

        tl.to(section, {
            scale: 1,
            ease: CustomEase.create('custom', '0.22, 1, 0.36, 1')
        });
    });
};

export default initScaleScroll;
